<template>
<div>贡献</div>
</template>

<script>
export default {
name: "contribution"
}
</script>

<style scoped>

</style>
